import { Form, Modal, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import Avatar from 'design-system/avatar'
import { AvatarSizes } from 'design-system/avatar/src/resources/Avatar.enum'
import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { IEnrolData, Values } from '../types'
import { State, FinalState } from './forms'
import { prefix } from './constants'
import Notes from './forms/Notes'
import styles from './ModalBody.module.scss'

interface ModalBodyProps {
  values?: Values
  setValue: <K extends keyof Values>(key: K, value: Values[K]) => void
  data: IEnrolData
}

export const ModalBody = ({ values, setValue, data }: ModalBodyProps) => {
  const { t } = useTranslation()
  const tRelative = useTranslationRankmi({
    prefix,
  })
  const { name, lastname, avatar, position, identifier } = data.user

  const fullName = [name, lastname].filter(Boolean).join(' ')

  return (
    <Modal.Body className="ml-3 mr-3">
      <Row>
        <Col md={5}>
          <Row className="h-100 align-content-center" noGutters>
            <Col xs={12}>
              <div className="d-flex justify-content-center">
                <Avatar
                  src={avatar}
                  sizes={AvatarSizes.XExtraLarge}
                  className={styles.avatar}
                />
              </div>
            </Col>
            <Col xs={12}>
              <h1 className="mt-2 text-truncate d-block">{fullName}</h1>
              {position && (
                <div className="mb-2 text-truncate d-block">
                  {tRelative('labels.position')}: {position}
                </div>
              )}
              {identifier && (
                <div className="mb-2 text-truncate">{identifier}</div>
              )}
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <h5
            className={classNames(
              'text-center d-none d-md-block',
              styles.title
            )}
          >
            {t('administration.monitor.finishCourse.title')}
          </h5>
          <hr />
          <Form.Group>
            <State
              value={values?.state}
              onChange={(option) => {
                setValue('state', option?.value)
              }}
            />
          </Form.Group>
          <Form.Group>
            <FinalState
              value={values?.finalState}
              onChange={(option) => {
                setValue('finalState', option?.value)
              }}
            />
          </Form.Group>
          <Form.Group>
            <InputLabel label={tRelative('form.attendance')} />
            <Form.Control
              type="number"
              value={values?.attendance ?? ''}
              onChange={({ target }) =>
                setValue(
                  'attendance',
                  target.value === '' ? undefined : +target.value
                )
              }
            ></Form.Control>
          </Form.Group>
          <Notes
            value={values?.notes}
            onChange={(value) => {
              setValue('notes', value)
            }}
          />
        </Col>
      </Row>
    </Modal.Body>
  )
}
